import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Link2, FolderArchive, Loader2 } from "lucide-react";

export function RemoteLinkButton({ p, onDone }) {
  const [open, setOpen] = useState(false);
  const [sms, setSms] = useState(true);
  const [email, setEmail] = useState(!!p.client_data?.email);
  const [busy, setBusy] = useState(false);
  const invia = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/mup/pratiche/${p.pratica_id}/remote-link`, { origin: window.location.origin, via_sms: sms, via_email: email });
      let copiato = false;
      try { await navigator.clipboard.writeText(data.sign_link); copiato = true; } catch { /* ignore */ }
      toast.success(`Link di firma inviato via ${data.inviato_via.join(" e ")}${copiato ? " · link copiato negli appunti" : ""}`, { description: data.sign_link });
      setOpen(false); onDone();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <>
      <Button data-testid="mup-remote-link-btn" variant="outline" onClick={() => setOpen(true)} className="border-teal-300 text-teal-800 hover:bg-teal-50">
        <Link2 className="h-4 w-4 mr-2" /> Invia link di firma
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="mup-remote-dialog">
          <DialogHeader><DialogTitle>Firma a distanza</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Il cliente riceve un link personale (valido 14 giorni): apre e legge il MUP sul proprio telefono, conferma la presa visione e firma con il codice OTP ricevuto via SMS.</p>
          <div className="space-y-2 text-sm">
            <label className="flex items-center gap-2"><Checkbox checked={sms} onCheckedChange={(v) => setSms(!!v)} data-testid="mup-remote-sms" /> SMS al {p.client_data?.mobile || "cellulare non indicato"}</label>
            <label className={`flex items-center gap-2 ${p.client_data?.email ? "" : "opacity-50"}`}><Checkbox checked={email} disabled={!p.client_data?.email} onCheckedChange={(v) => setEmail(!!v)} data-testid="mup-remote-email" /> Email a {p.client_data?.email || "email non indicata"} (con il MUP in allegato)</label>
          </div>
          <DialogFooter>
            <Button onClick={invia} disabled={busy || (!sms && !email)} className="brand-gradient text-white border-0" data-testid="mup-remote-invia">
              {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Invia il link
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}

export function FascicoloButton({ p }) {
  const [busy, setBusy] = useState(false);
  const scarica = async () => {
    setBusy(true);
    try {
      const { data } = await api.get(`/mup/pratiche/${p.pratica_id}/fascicolo-compagnia`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url; a.download = `Fascicolo_${p.code}.zip`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Fascicolo scaricato");
    } catch { toast.error("Impossibile generare il fascicolo"); }
    finally { setBusy(false); }
  };
  return (
    <Button data-testid="mup-fascicolo-btn" variant="outline" onClick={scarica} disabled={busy || !p.hash}>
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <FolderArchive className="h-4 w-4 mr-2" />} Fascicolo per la Compagnia
    </Button>
  );
}
